import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  homeIntroPlayed: boolean
  homeIntroRunning: boolean
}

type Actions = {
  markIntroPlayed: () => void
  // eslint-disable-next-line no-unused-vars
  setHomeIntroRunning: (running: boolean) => void
}

const initialState: State = {
  homeIntroPlayed: false,
  homeIntroRunning: false
}

const useHomeHeroStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,
      markIntroPlayed: () =>
        set((state) => {
          state.homeIntroPlayed = true
          state.homeIntroRunning = false
        }),
      setHomeIntroRunning: (running) =>
        set((state) => {
          state.homeIntroRunning = running
        })
    }))
  )
)

export { useHomeHeroStore }
